<template>
  <v-app>
    <Header/>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import Header from './components/layout/Header'

export default {
  name: 'App',
  components: {
    Header,
  }
}
</script>

<style>
  body {
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.4;
    background-color: #EDEDED !important;    
  }

  div.card {
    border: none;
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 15px;
    text-align: center;
  }

  h5.card-title {
    font-weight: normal;
    color: #808080;
  }
</style>
